import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";
import { LocalFormSchema } from "../logic/applicationUpdateSchema";
import { useFieldArray, UseFormReturn } from "react-hook-form";

type Page = 'identity' | 'names' | 'birth' | 'addresses' | 'documents'
type TestingDataProps = {
  form: UseFormReturn<LocalFormSchema>,
  page: Page,
}

const TestingData: React.FC<TestingDataProps> = ({ form, page }) => {
  return (
    <Alert severity="info" sx={{ marginTop: 3 }}>
      <AlertTitle>Only shown in Test Mode</AlertTitle>
      <Button variant="contained" onClick={() => {
        if (page === 'identity') {
          form.setValue('AdditionalApplicantDetails.LanguagePreference', 'english')
          form.setValue('Gender', 'male')
          form.setValue('AdditionalApplicantDetails.ContactNumber', '07712345678')
          form.setValue('NiNumber', 'AB123456B')
        } else if (page === 'names') {
          form.setValue('Title', 'MR')
          form.setValue('Forename', 'JOHN')
          form.setValue('Middlenames', { Middlename: ['JAMES'] }) // TODO: Find out why this doesn't work!
          form.setValue('PresentSurname', 'SMITH')
        } else if (page === 'birth') {
          form.setValue('DateOfBirth', '1980-10-13')
          form.setValue('AdditionalApplicantDetails.BirthTown', 'London')
          form.setValue('AdditionalApplicantDetails.BirthCounty', 'Greater London')
          form.setValue('AdditionalApplicantDetails.BirthCountry', 'GB')
          form.setValue('AdditionalApplicantDetails.BirthNationality', 'British')
        } else if (page === 'addresses') {
          form.setValue('CurrentAddress', {
            Address: {
              AddressLine1: 'My House',
              AddressLine2: 'Some Road',
              AddressTown: 'Townsville',
              AddressCounty: 'Greater London',
              Postcode: 'NW1 0AA',
              CountryCode: 'GB',
            },
            ResidentFromGyearMonth: '2023-01',
          })
          form.setValue('PreviousAddress', [
            {
              Address: {
                AddressLine1: 'Another House',
                AddressLine2: 'Some Road',
                AddressTown: 'Townsville',
                AddressCounty: 'Greater London',
                Postcode: 'NW1 0AA',
                CountryCode: 'GB',
              },
              ResidentDates: {
                ResidentToGyearMonth: '2023-01',
                ResidentFromGyearMonth: '2010-01',
              },
            },
          ])
        } else if (page === 'documents') {
          form.setValue('_hasPassport', true)
          form.setValue('ApplicantIdentityDetails.PassportDetails', {
            PassportNumber: '123456789',
            PassportIssueDate: '2020-01-01',
            PassportDob: '1980-10-13',
            PassportNationality: 'British',
          })
          form.setValue('_hasDriverLicence', true)
          form.setValue('ApplicantIdentityDetails.DriverLicenceDetails', {
            DriverLicenceNumber: 'SMITH810130JAAA',
            DriverLicenceDOB: '1980-10-13',
            DriverLicenceType: 'photo',
            DriverLicenceValidFrom: '2000-01-11',
            DriverLicenceIssueCountry: 'GB',
          })
        }
        form.trigger()
        console.log('Completed with Test Data', { page, form })
      }}>Complete with Test Data</Button>
    </Alert>
  )
}

export default TestingData
